import { render, staticRenderFns } from "./FooterLayout.vue?vue&type=template&id=06bc4f7b&"
import script from "./FooterLayout.vue?vue&type=script&setup=true&lang=js&"
export * from "./FooterLayout.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports